import { AIChatbotFAQFragment } from 'types/graphql'

import CustomAnswerModal from 'src/components/AIAssistant/CustomAnswerModal'
import { EllipsisButton } from 'src/components/EllipsisButton'
import { ActionItem } from 'src/govwell-ui/types'
import useDisclosure from 'src/hooks/use-disclosure'
import DeleteCustomAnswerModal from 'src/pages/AIAssistantTrainPage/DeleteCustomAnswerModal'
import { RefetchFnType } from 'src/types'

type ButtonProps = {
  aiChatbotFAQ: AIChatbotFAQFragment
  refetch: RefetchFnType
}

const CustomAnswersTableButtons = (props: ButtonProps) => {
  const { aiChatbotFAQ, refetch } = props

  const deleteModalState = useDisclosure()
  const deleteItem: ActionItem = {
    label: 'Delete',
    key: `${aiChatbotFAQ.id}-delete`,
    icon: 'FaTrash',
    onClick: deleteModalState.open,
  }

  const editModalState = useDisclosure()
  const editItem: ActionItem = {
    label: 'Update',
    key: `${aiChatbotFAQ.id}-edit`,
    icon: 'FaPencil',
    onClick: editModalState.open,
  }

  const items: ActionItem[] = [editItem, deleteItem]

  return (
    <>
      <EllipsisButton items={items} />
      {deleteModalState.isOpen && (
        <DeleteCustomAnswerModal
          id={aiChatbotFAQ.id}
          onClose={deleteModalState.close}
          refetch={refetch}
        />
      )}
      {editModalState.isOpen && (
        <CustomAnswerModal
          modalType="edit"
          aiChatbotFAQ={aiChatbotFAQ}
          onSubmit={refetch}
          onClose={editModalState.close}
        />
      )}
    </>
  )
}

export default React.memo(CustomAnswersTableButtons)
